<template>
  <div class="vehicle-container">
    <div class="vehicle-list-tools">
      <el-form class="battery-form" :inline="true" :model="formData">
        <el-form-item label="VIN">
          <el-input
            v-model="formData.sn"
            placeholder="请输入车辆VIN码"
            size="small"
            class="area-form-item"
            style="width: 180px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="标签">
           <el-tree-select
            ref="group-select-tree"
            class="group-select-tree"
            v-model="formData.orgId"
            :selectParams="selectParams"
            :treeParams="treeParams"
            show-checkbox
            :multiple="true"
            style="width: 300px"
          >
          </el-tree-select>
        </el-form-item>
        <el-form-item label="电池类型">
          <el-select v-model="formData.state" style="width: 220px">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电池型号">
          <el-input
            v-model="formData.sn"
            placeholder="请输入电池型号"
            size="small"
            class="area-form-item"
            style="width: 180px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="故障状态">
          <el-select v-model="formData.state" style="width: 220px">
            <el-option label="全部" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="停用" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right; marginright: 0px">
          <el-button type="primary" @click="getData()">搜索</el-button>
          <el-button @click="resetFrom()">重置</el-button>
        </el-form-item>
        <!-- <el-row>
          <el-form-item>
            <el-button type="primary" @click="addHandle()">新增</el-button>
          </el-form-item>
        </el-row> -->
      </el-form>
    </div>
    <div class="vehicle-table-container">
      <div class="vehicle-table-content">
        <el-table
          style="width: 100%"
          height="100%"
          :data="list"
          v-loading="loading"
        >
          <el-table-column label="车辆VIN码" prop="sn" width="300">
            <template slot-scope="scope">
              {{scope.row.vin || '-'}}
            </template>
          </el-table-column>
          <el-table-column label="电池类型" prop="producer">
            <template slot-scope="scope">
              <span style="text-align: center;">{{scope.row.type || '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="电池型号" >
            <template slot-scope="scope">
              <span style="text-align: center;">{{scope.row.model || '-'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="故障状态" >
            <template slot-scope="scope">
              <span style="color: #008000" v-if="scope.row.alarm == 1">无故障</span>
						<span style="color: #ff0000" v-else>不生效</span>
            </template>
          </el-table-column>
          <el-table-column label="故障状态" >
            <template slot-scope="scope">
              <span style="color: #008000" v-if="scope.row.cdStatus == 1">未充电</span>
						<span style="color: #ff0000" v-else>充电中</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button @click="jumpDetailPage(scope.row, 1)" type="text" size="mini"
                >点击查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="vehicle-table-page">
        <div class="vehicle-table-page-container">
          <el-pagination
            background
            :current-page="formData.pageIndex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/axios";
import moment from "moment";
import "./Index.less";
export default {
  name: "AlgorithmManagement",
  data() {
    return {
      list: [
        {vin: 'e1c4e759-2910-47bf-a56e-6f132c443', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '132331sadsa'},
        {vin: 'a82189fa-ba73-41e8-8150-93d8e4d39', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '13233sadsa'},
        {vin: '11baa91c-8627-4c8b-8150-cef550894', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 2, id: '132333sadsa'},
        {vin: 'b309e164-ffd9-4a72-a9a0-189222478', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '1323q3sadsa'},
        {vin: '59155991-9b99-43b1-b220-4293fa599', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '1323d3sadsa'},
        {vin: 'cba9c91d-e1e8-4682-9611-da323fc45', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '1323w3sadsa'},
        {vin: 'e1c4e759-2910-47bf-a56e-6f132c443', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 1, id: '13233sadsa'},
        {vin: 'e1cee259-2av0-478f-a56e-11111c443', type: 'CL', model: 'SC7003AEBEV', alarm: 1, cdStatus: 2, id: '1323r3sadsa'},
        
      ],
      total: 8,
      loading: false,
      visable: false,
      sourceList: [],
      formData: {
        sn: null,
        level: null,
        status: null,
        source: null,
        startTime: null,
        endTime: null,
        time: null,
        firstPerson: null,
        lastPerson: null,
        organId: null,
        orderBy: null,
        pageIndex: 1,
        pageSize: 20,
        state: null
      },
      selectParams: {
        multiple: false,
        clearable: true,
        placeholder: "请选择标签",
      },
      treeParams: {
        clickParent: true,
        filterable: false,
        "check-strictly": true,
        "default-expand-all": true,
        "expand-on-click-node": false,
        data: [],
        props: {
          children: "childs",
          label: "orgName",
          value: "orgId",
        },
      },
    };
  },
  components: {  },
  mounted() {
    this.formData.organId = localStorage.getItem("organId");
    // this.getData();
    // this.getSourceList()
    this.getOrgTreeData()
  },
  methods: {
    getOrgTreeData() {
      this.treeParams.data = [
        {
          id: 1,
          orgName: '未分组标签',
          orgId: 1,
          childs: [
            {id: 2, orgId: 2, orgName: '未分组标签-1'},
            {id: 3, orgId: 3, orgName: '未分组标签-1'},
            {id: 4, orgId: 4, orgName: '未分组标签-1'},
            {id: 5, orgId: 5, orgName: '未分组标签-1'},
          ]
        },
        {
          id: 6,
          orgName: '预警紧急程度',
          orgId: 6,
          childs: [
            {id: 7, orgId: 7, orgName: '严重'},
            {id: 8, orgId: 8, orgName: '紧急'},
            {id: 9, orgId: 9, orgName: '待观察'},
          ]
        }
      ];
      this.$nextTick(() => {
        this.$refs["group-select-tree"].treeDataUpdateFun(this.treeParams.data);
      });
    },
    //获取列表数据
    // getData() {
    //   this.loading = true;
    //   axios
    //     .post(`/api/customerServiceCenter/query`, this.formData)
    //     .then((res) => {
    //       const { list, total, page } = res;
    //       this.list = list;
    //       this.total = total;
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //       this.$message.error(err);
    //     });
    // },
    //重置
    resetFrom() {
      this.formData = {
        sn: null,
        level: null,
        status: null,
        source: null,
        startTime: null,
        endTime: null,
        time: null,
        firstPerson: null,
        lastPerson: null,
        organId: localStorage.getItem("organId"),
        orderBy: null,
        pageIndex: 1,
        pageSize: 20,
      };
      this.getData();
    },
    // //获取来源列表
    // getSourceList() {
    //   axios
    //     .post(`/api/customerServiceCenter/source`)
    //     .then((res) => {
    //       this.sourceList = res
    //     })
    //     .catch((err) => {
    //       this.$message.error(err);
    //     });
    // },
    // //时间选择
    // timeChange(data) {
    //   if (data) {
    //     this.formData.startTime = this.DateToStr(data[0]);
    //     this.formData.endTime = this.DateToStr(data[1]);
    //   }
    // },
    // //日期转字符串
    // DateToStr(date) {
    //   var year = date.getFullYear(); //年
    //   var month = date.getMonth(); //月
    //   var day = date.getDate(); //日
    //   var hours = date.getHours(); //时
    //   var min = date.getMinutes(); //分
    //   var second = date.getSeconds(); //秒
    //   return (
    //     year +
    //     "-" +
    //     (month + 1 > 9 ? month + 1 : "0" + (month + 1)) +
    //     "-" +
    //     (day > 9 ? day : "0" + day) +
    //     " " +
    //     (hours > 9 ? hours : "0" + hours) +
    //     ":" +
    //     (min > 9 ? min : "0" + min) +
    //     ":" +
    //     (second > 9 ? second : "0" + second)
    //   );
    // },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.formData.pageIndex = val;
      this.getData();
    },
    // //跳转详情
    // addHandle(row) {
    //   this.$router.push({
    //     name: "AddCustomer",
    //     params: {
          
    //     },
    //   });
    // },
    // jumpDetailPage(row, type) {
    //   this.$router.push({
    //     name: "AddCustomer",
    //     params: {
    //       id: row.id,
    //       type: type
    //     },
    //   });
    // },
    // setHandle(item) {
    //   this.visable = true;
    //   let childProblem = item.childProblemTextList||[].toString()
    //   this.$nextTick(() => {
    //     this.$refs.setModel.init();
    //     this.$refs.setModel.title = item.code + " 工单处理";
    //     this.$refs.setModel.dataForm.sn = item.sn;
    //     this.$refs.setModel.dataForm.questionTypeText = item.questionTypeText;
    //     this.$refs.setModel.dataForm.childProblemTextList = childProblem
    //     this.$refs.setModel.dataForm.resultText = item.resultText
    //     this.$refs.setModel.dataForm.sourceId = item.id
    //   });
    // }
  },
};
</script>